/**
 * Transform an array of resource usages from seconds to minutes.
 * If unit is not in seconds, leave as is.
 */
import { ResourceUsage } from '../types';

const transformDate = (date: string): string => date.split('T')[0]; // Extract the date part from the ISO string

export function transformUsage(resources: ResourceUsage[]): ResourceUsage[] {
    if (!resources) {
        return [];
    }

    return resources.map((resource) => {
        if (resource.unit !== 'seconds') {
            return {
                ...resource,
                usage: resource.usage.map((item) => ({
                    ...item,
                    date: transformDate(item.date),
                })),
            };
        }

        return {
            ...resource,
            unit: 'minutes',
            usage: resource.usage.map((item) => ({
                date: transformDate(item.date),
                quantity: Math.round(item.quantity / 60),
            })),
        };
    });
}
